export const createCallToAttentionService =
  (fetch) => async (formData) => {
    try {
      const response = await fetch({
        url: "/api/v1/llamados-atencion",
        method: "post",
        body: formData,
        contentType: "multipart/form-data",
      });

      return response;
    } catch (error) {
      throw new Error(error.response?.data?.message || error.message);
    }
  };
